import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import * as React from "react";

const enum fields {
    textFieldValue = "textFieldValue"
}

interface Props extends WidgetProps {
    fields: {
        [fields.textFieldValue]: string;
    };
}

const CustomIncentiveForm: React.FC<Props> = ({ fields }) => {
  
    React.useEffect(() => {
        loadSurveyMonkeyScript();
    }, []);

    function loadSurveyMonkeyScript(){
        const el = document.createElement("script");
        el.src = fields.textFieldValue;
        document.body.appendChild(el);
        el.onload = function () {
            document.body.removeChild(el);
            setTimeout(() => {
                const widgetForms = [...document.getElementsByClassName("smcx-widget")];
                if(widgetForms.length > 1){
                    for( const div of [...document.getElementsByClassName("smcx-widget")] ){
                        div.parentNode?.removeChild(div);
                        widgetForms.pop();
                        if(widgetForms.length === 1){
                            break;
                        }
                    }
                }
            }, 500);
        };
        el.onerror = function () {
            document.body.removeChild(el);
        }
    }
    return <div id="smcx-sdk"></div>
};
  
const definition: WidgetDefinition = {
    group: "Common",
    displayName: "Custom Incentive Form",
    fieldDefinitions: [
        {
            name: fields.textFieldValue,
            displayName: "Script src",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General",
            placeholder: "Enter URL",
            isRequired: true,
        }
    ],
};

const widgetModule: WidgetModule = {
    component: CustomIncentiveForm,
    definition,
};

export default widgetModule;
